import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { InvoiceRow } from '../common/invoiceElements'
import { Divider, Total, TotalLabel } from './InvoiceDetails.style'
import { InvoiceDetailsPanel } from '../common/invoiceElements'
import InvoiceDetailsCommon, { InvoiceDetailsCommonProps } from './InvoiceDetailsCommon'
import { FormatAmount } from '../../../common/formatters'
import PdfButtonIcon from '../common/PdfButtonIcon'
import DisclaimerLabel from '../DisclaimerLabel/DisclaimerLabel.component'

export interface InvoiceDetailsAFSProps extends InvoiceDetailsCommonProps {
  total: number
  noPdf?: boolean
  pdfLinkLabel?: string
  onShowPdf?: () => void
  isAuthenticated: boolean
}

const InvoiceDetailsAFS = (invoiceDetailsAFSProps: InvoiceDetailsAFSProps) => {
  const { t } = useTranslation()
  const isAuthenticated = invoiceDetailsAFSProps.isAuthenticated
  const invoiceDetailsCommonProps: InvoiceDetailsCommonProps = {
    detailsLabel: invoiceDetailsAFSProps.detailsLabel,
    dueDateLabel: invoiceDetailsAFSProps.dueDateLabel,
    dueDate: invoiceDetailsAFSProps.dueDate,
    recipientLabel: invoiceDetailsAFSProps.recipientLabel,
    detailsAllowCopy: invoiceDetailsAFSProps.detailsAllowCopy,
    companyName: invoiceDetailsAFSProps.companyName,
    accountNumberLabel: invoiceDetailsAFSProps.accountNumberLabel,
    iban: invoiceDetailsAFSProps.iban,
    referenceNumberLabel: invoiceDetailsAFSProps.referenceNumberLabel,
    reference: invoiceDetailsAFSProps.reference,
    bicLabel: invoiceDetailsAFSProps.bicLabel,
    bic: invoiceDetailsAFSProps.bic
  }

  return (
    <InvoiceDetailsPanel>
      <InvoiceDetailsCommon {...invoiceDetailsCommonProps} />
      <Total>
        <FormatAmount>{invoiceDetailsAFSProps.total}</FormatAmount> €
      </Total>
      <TotalLabel>{t('ontimeInvoiceAmountDue.label')}</TotalLabel>
      <>
        <Divider />

        {!invoiceDetailsAFSProps.noPdf && (
          <>
            <InvoiceRow size="small">
              <label>{t(invoiceDetailsAFSProps.pdfLinkLabel || 'ontimeAsPdfButton.label')}</label>
              <span>
                <PdfButtonIcon
                  handleOnShowPdf={invoiceDetailsAFSProps.onShowPdf}
                  isAuthenticated={isAuthenticated}
                />
              </span>
            </InvoiceRow>
            {!isAuthenticated && (
              <InvoiceRow size="small">
                <DisclaimerLabel disclaimerText={t('pdfInvoiceNotAuthenticated.label')} />
              </InvoiceRow>
            )}
          </>
        )}
      </>
    </InvoiceDetailsPanel>
  )
}

export default InvoiceDetailsAFS
